import React from 'react';
import { Box, Typography } from '@mui/material';
import { useI18n } from '../../../lib/hook/useI18n';
import PrivacyPolicyLink from '../../ConsentPromp/PrivacyPolicyLink';

interface Props {
  isConsentDeclinedSuppression?: boolean;
  requiresPasscode?: boolean;
  requiresEmail?: boolean;
  shouldVerifyEmail: boolean;
  buttonText: string;
}

const UnifiedSecurityDialogConsent: React.FC<Props> = ({
  isConsentDeclinedSuppression,
  requiresPasscode,
  requiresEmail,
  shouldVerifyEmail,
  buttonText,
}) => {
  const { i18nClasses, t, tc } = useI18n();

  if (requiresPasscode && !shouldVerifyEmail) {
    return (
      <Box>
        <Typography
          className={i18nClasses.root}
          color="textSecondary"
          variant="body2"
        >
          {t('room.welcome.modal.passcode_only.consent.description')}
        </Typography>
        <Typography
          className={i18nClasses.root}
          color="textSecondary"
          variant="body2"
          sx={{ mt: 2 }}
        >
          {tc(
            'room.welcome.modal.passcode_only.consent.terms',
            { actionText: buttonText },
            {
              privacyPolicyLink: (
                <PrivacyPolicyLink color="primary" variant="body2" />
              ),
            },
            false
          )}
        </Typography>
      </Box>
    );
  }

  let consentKey: string;

  if (requiresPasscode && requiresEmail) {
    consentKey = 'room.welcome.modal.email_passcode.consent';
  } else {
    consentKey = isConsentDeclinedSuppression
      ? 'room.welcome.modal.newer_consent.consent_suppression'
      : 'room.welcome.modal.newer_consent.consent';
  }

  return (
    <Box>
      <Typography
        className={i18nClasses.root}
        color="textSecondary"
        variant="body2"
      >
        {tc(
          consentKey,
          { actionText: buttonText },
          {
            privacyPolicyLink: (
              <PrivacyPolicyLink color="primary" variant="body2" />
            ),
          },
          true
        )}
      </Typography>
    </Box>
  );
};

export default UnifiedSecurityDialogConsent;
